import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";

export const MatchBar = ({ score, status }) => {
  if (status === "FAILED")
    return (
      <span className="flex w-fit items-center gap-1.5 text-red-400 text-[0.73rem] bg-red-500/10 px-2 py-0.5 rounded-full border border-red-500/20">
        Analysis failed
      </span>
    );

  // While a retrigger is actively running, the old score is stale by
  // definition. Show the spinner instead of the previous result so the row
  // reflects the live matcher state.
  if (status === "IN_PROGRESS")
    return (
      <span className="flex items-center gap-1.5 text-[#818cf8] text-[0.73rem]">
        <Loader2 size={11} className="animate-spin" /> Analyzing…
      </span>
    );

  // Score-before-NOT_STARTED: a row can carry a stale/default NOT_STARTED
  // status while a live WS update already delivered the real score — don't
  // let the status hide a score we actually have.
  if (score == null && status === "NOT_STARTED")
    return <span className="text-text-secondary text-[0.73rem]">—</span>;

  if (score == null)
    return (
      <span className="flex items-center gap-1.5 text-[#818cf8] text-[0.73rem]">
        <Loader2 size={11} className="animate-spin" /> Analyzing…
      </span>
    );

  const pct = Math.min((score / 10) * 100, 100);

  const level = score >= 8 ? "High" : score >= 5 ? "Normal" : "Low";

  return (
    <div className="flex items-center gap-2 group relative">
      {/* Tooltip */}
      <div
        className="
          absolute -top-6 left-0
          opacity-0 group-hover:opacity-100
          translate-y-1 group-hover:translate-y-0
          transition-all duration-200
          pointer-events-none
          z-20
        "
      >
        <div
          className={cn(
            "px-2.5 py-1 rounded-md text-[11px] font-medium shadow-lg border whitespace-nowrap",
            score >= 8
              ? "bg-[#87AA92]/15 text-[#87AA92] border-[#87AA92]/30"
              : score >= 5
                ? "bg-yellow-500/15 text-yellow-400 border-yellow-500/30"
                : "bg-red-500/15 text-red-400 border-red-500/30",
          )}
        >
          {level} Match • {score.toFixed(1)}/10
        </div>
      </div>

      {/* Track */}
      <div className="flex-1 h-2 rounded-full min-w-[100px] bg-background-tertiary overflow-hidden">
        <div
          className={cn("h-full rounded-full transition-all duration-500 ease-in-out", score >= 8 ? "bg-[#87AA92]" : score >= 5 ? "bg-[#eab308]" : "bg-[#B32929]")}
          style={{
            width: `${pct}%`,
          }}
        />
      </div>

      {/* Score */}
      <span className="text-xs w-7 text-right text-text-primary">{score.toFixed(1)}</span>
    </div>
  );
};
